import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { MissionVisibility } from '../types/ui/missionVisibility';

interface MissionVisibilityStore {
  missionVisibility: MissionVisibility;
  toggleMissionVisibility: () => void;
  setMissionVisibility: (visibility: MissionVisibility) => void;
}

export const useMissionVisibilityStore = create<MissionVisibilityStore>()(
  persist(
    (set) => ({
      missionVisibility: 'selected vehicle',
      toggleMissionVisibility: () =>
        set((state) => ({
          missionVisibility: state.missionVisibility === 'all' ? 'selected vehicle' : 'all'
        })),
      setMissionVisibility: (visibility: MissionVisibility) => set({ missionVisibility: visibility })
    }),
    {
      name: 'mission-visibility-store'
    }
  )
);
